<template>
    
    <div class="media-image">
        <div 
            class="image-container"
            ref="imageContainer"
            :style="{ paddingBottom: padding+'%', backgroundColor: backgroundColor}"
        >
            <image-loader
                :data="data.image.urls"
                :containerWidth="containerWidth"
                @loaded="onImageLoaded"
            />
            <!-- IDEA: Add placeholder image, small thumbnail before fullsize image is loaded  ->  :placeholder="https://images.pexels.com/photos/33109/fall-autumn-red-season.jpg?w=100" -->
        </div>
    </div>
    
</template>


<script>
import ImageLoader from '@/components/ImageLoader'
import Size from '@/plugins/WindowSize'

export default {
    
    props: {
        data: {
            type: Object,
            required: true,
            // EXAMPLE OBJECT
            // {
            //     "type": "media-image",
            //     "backgroundColor": "#F0F0F0",
            //     "image": {
            //         "type": "image",
            //         "comment": "Image OBJ. Has aspect ratio & array of urls to image sizes. Default image widths are 768W, 1080W, 1920W. Images have flexible height",
            //         "aspectRatio": "16:9",
            //         "urls": [
            //             {
            //                 "url": "https://source.unsplash.com/collection/3657445/768x432",
            //                 "width": 768,
            //                 "height": 432
            //             },
            //             {
            //                 "url": "https://source.unsplash.com/collection/3657445/1080x608",
            //                 "width": 1080,
            //                 "height": 608
            //             },
            //             {
            //                 "url": "https://source.unsplash.com/collection/3657445/1920x1080",
            //                 "width": 1920,
            //                 "height": 1080
            //             }
            //         ]
            //     }
            // },
        }
    },
    
    components: {
        ImageLoader
    },
    
    data() {
        return {
            containerWidth: 0,
            backgroundColor: '',
            aspectRatio: 0,
            padding: 0,
            backgroundImage: '',
            loaded: false,
        }
    },
    
    created() {
        Size.addListener(this.onResize)
        this.backgroundColor = this.data.backgroundColor
    },
    
    destroyed() {
        Size.removeListener(this.onResize)
    },
    
    mounted() {
        // Set asperct ratio
        let as = this.data.image.aspectRatio.split(":")
        let w = as[0]
        let h = as[1]
        this.aspectRatio = h/w;
        
        this.onResize()
    },
    
    methods: {
        
        onImageLoaded(event) {
            this.loaded = true
            this.backgroundImage = event.src

            this.$emit('loaded')
        },
        
        onResize() {
            if (this.$refs.imageContainer !== undefined) {
                
                this.containerWidth = this.$refs.imageContainer.offsetWidth
                var containerHeight
                
                // Round the height of images to closest 10, 20 or 30px.
                // This way we can assure that the grid items have same 
                // space beneath. Check rowHeight & rowSpan in Work.vue
                if (this.$router.currentRoute.name === 'Work' || this.$router.currentRoute.name === 'WorkFilter') {
                    var rowHeight = (window.innerWidth < 1024) ? 10 : (window.innerWidth < 1440) ? 20 : 30;
                    containerHeight = Math.round(this.containerWidth*this.aspectRatio / rowHeight) * rowHeight; // round off to each 20 - Fit the /work grid!
                }
                // Case page
                else {
                    containerHeight = this.containerWidth*this.aspectRatio;
                }
                
                this.padding = (containerHeight / this.containerWidth) * 100
            }
        },

    },
    
    computed: {
        isCaseFullWidth() {
            return this.$store.state.isCaseFullWidth
        },
    },
    
    watch: {
        isCaseFullWidth() {
            // Transition is playing - Wait until animation is done before updating image size
            if (this.resizeTimer) {
                window.clearTimeout(this.resizeTimer);
            }
            this.resizeTimer = window.setTimeout(this.onResize, 650) // Animation takes 600ms
        },
    },
    
}

</script>


<style lang="scss" scoped>
@import '../scss/variables';

.media-image {
    .image-container {
        position: relative;
        height: 0;
        background-size: cover;
        background-repeat: no-repeat;
        // transition: background-color 1s;
        
        img {
            position: absolute;
            object-fit: cover;
            width: 100%;
            height: 100%;
            opacity: 0;
            transition: opacity 2s ease-out;
            
            &.loaded {
                opacity: 1;
            }
        }
    }
}
</style>
